/**
 * data-testid values of the Paddle integration card.
 * Mirror of `.claude/skills/segmently-test-kit/src/selectors/integrations.ts`
 * → `INTEGRATIONS.paddle` (specs import the kit registry; keep both identical).
 */
export type PaddleTestEnvironment = 'sandbox' | 'production';

export const PADDLE_CONNECT_TEST_IDS = {
  connectionError: 'paddle-connection-error',
  checkStatus: 'paddle-check-status',
  secretDialog: 'paddle-secret-dialog',
  secretInput: 'paddle-secret-input',
  secretSave: 'paddle-secret-save',
  editSecret: (env: PaddleTestEnvironment) => `paddle-secret-edit-${env}`,
  form: 'paddle-connect-form',
  apiKey: 'paddle-api-key',
  clientToken: 'paddle-client-token',
  webhookSecret: 'paddle-webhook-secret',
  envToggle: 'paddle-connect-env',
  connectSubmit: 'paddle-connect-submit',
  /** "Advanced Settings" toggle; the webhook-secret field sits inside its Collapse. */
  advancedToggle: 'paddle-connect-advanced',
  /** Per-environment status box; carries `data-connected="true|false"`. */
  status: (env: PaddleTestEnvironment) => `paddle-status-${env}`,
  /** Per-environment "Connect" button shown when that environment is not connected. */
  connectEnvButton: (env: PaddleTestEnvironment) => `paddle-status-${env}-connect`,
  /** The "Disconnect" button that opens the menu. */
  disconnectMenu: 'paddle-disconnect-menu',
  disconnect: (env: PaddleTestEnvironment | 'all') => `paddle-disconnect-${env}`,
  /** Rendered by P6 (webhook health rows); registered now so the names are fixed. */
  webhookStatus: (env: PaddleTestEnvironment) => `paddle-webhook-status-${env}`,
  webhookRow: (env: 'sandbox' | 'production', row: 'receipt' | 'processing' | 'delivery') => `paddle-webhook-${env}-${row}`,
  webhookDiagnostic: 'paddle-webhook-diagnostic',
  refreshHealth: 'paddle-webhook-refresh',
  /** Read-only input holding the destination URL. */
  webhookUrl: 'paddle-webhook-url',
} as const;
